type LegacyRecentSymbols = Record<string, number[] | number>;

// Convert any old non-array entries to be array entries
export function migrateRecentSymbolsToTimestampArrays(config: any) {
  if (config == null || config.recentSymbols == null || typeof config.recentSymbols !== 'object') {
    return;
  }

  const recentSymbols = config.recentSymbols as LegacyRecentSymbols;
  const migratedRecentSymbols: Record<string, number[]> = {};

  for (const symbol in recentSymbols) {
    const timestamps = recentSymbols[symbol];
    migratedRecentSymbols[symbol] = Array.isArray(timestamps) ? timestamps : [timestamps];
  }

  config.recentSymbols = migratedRecentSymbols;
}
